/*global language*/
import date from 'date-and-time'
import de from 'date-and-time/locale/de'
import en from 'date-and-time/locale/en'
import fr from 'date-and-time/locale/fr'
import it from 'date-and-time/locale/it'

// Setting default language
let langs = { de, en, fr, it }
date.locale(langs[language.current])

export default date
